import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.css';
import '../less/index.less';
import 'bootstrap';

import './accounts/registration';
import './accounts/login';
import './accounts/reset';
import './accounts/profile';

import './statement/form';

import './eds/cryptopro';


// WEBPACK FOOTER //
// ./js/index.js